import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/TransactionAdUnit';

export const TRANSACTION_AD_UNIT_VIEW = `${rootActionPath}/VIEW`;
export const TRANSACTION_AD_UNIT_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const TRANSACTION_AD_UNIT_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
